export const AID_STUDIO_STEP = {
  BASIC_INFO: 'basic-info',
  FUNDS: 'funds',
  TUITION: 'tuition',
  MATRIX: 'matrix',
  CALCULATIONS: 'calculations',
  RESULTS: 'results',
} as const satisfies Record<string, string>;

export type AidStudioStepValue =
  (typeof AID_STUDIO_STEP)[keyof typeof AID_STUDIO_STEP];

export const AID_STUDIO_STEPS: Array<{
  value: AidStudioStepValue;
  label: string;
  isDisabled: boolean;
}> = [
  {
    value: AID_STUDIO_STEP.BASIC_INFO,
    label: 'Basic information',
    isDisabled: false,
  },
  { value: AID_STUDIO_STEP.FUNDS, label: 'Funds', isDisabled: false },
  { value: AID_STUDIO_STEP.TUITION, label: 'Tuition & COA', isDisabled: false },
  {
    value: AID_STUDIO_STEP.MATRIX,
    label: 'Awarding regimes',
    isDisabled: false,
  },
  {
    value: AID_STUDIO_STEP.CALCULATIONS,
    label: 'Calculations',
    isDisabled: false,
  },
  { value: AID_STUDIO_STEP.RESULTS, label: 'Results', isDisabled: false },
];

export const ENROLLMENT_TYPES = [
  { value: 'FIRST_YEAR', label: 'First year' },
  { value: 'TRANSFER', label: 'Transfer' },
];

export const DATASET_STATUSES = {
  IN_PROGRESS: 'IN_PROGRESS',
  CREATED: 'CREATED',
  FAILED: 'FAILED',
};

export const DEFAULT_ENTRY_TERM_YEAR = 2026;

export const DEFAULT_ENTRY_TERM = [
  { value: DEFAULT_ENTRY_TERM_YEAR, label: String(DEFAULT_ENTRY_TERM_YEAR) },
];

export const AID_MODEL_NAME_DISPLAY_MAX_LENGTH = 30;

export const AID_MODEL_NAME_MAX_LENGTH = 100;

export const AID_MODEL_DESCRIPTION_MAX_LENGTH = 500;

export const DATASET_DATE_FORMAT = 'MM.DD.YYYY, hh:mm A';

export const MODEL_SAVED_TOAST_TITLE = 'Model saved';
